module.exports = __webpack_public_path__ + "388e6e3d0b1ed702df01039eef45d279.MP3";